var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.864,
    height: 50.522,
    viewBox: "0 0 80.864 50.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9055799_bxl_tailwind_css_icon",
    "data-name": "9055799_bxl_tailwind_css_icon",
    d: "M68.712,20.786a17.08,17.08,0,0,1-7.722-5.63A23,23,0,0,0,42.432,6.038c-9.924-.73-18.723,6.585-20.216,16.807a12.864,12.864,0,0,1,14.151-6.261,17.491,17.491,0,0,1,7.722,5.672,22.988,22.988,0,0,0,18.558,8.992c9.924.73,18.723-6.585,20.216-16.807A12.751,12.751,0,0,1,68.712,20.786ZM16.151,41.711a17.08,17.08,0,0,1,7.722,5.63A23,23,0,0,0,42.432,56.46c9.924.73,18.723-6.585,20.216-16.807A12.864,12.864,0,0,1,48.5,45.913a17.491,17.491,0,0,1-7.722-5.672,23.107,23.107,0,0,0-18.558-8.992C12.292,30.519,3.493,37.834,2,48.056a12.751,12.751,0,0,1,14.151-6.345Z",
    transform: "translate(-2 -5.988)",
    fill: "#61dafb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.e3e56c5a9d574285348feb91cf679320.svg";
export { ForwardRef as ReactComponent };